export default "__VITE_ASSET__Cz5NsNl7__"